export const classes = {
  section: 'py-4 flex justify-between',
  leftCol: 'w-1/3 max-w-[400px] pr-6',
  rightCol: 'flex flex-1 flex-col items-end',
  subtitle: 'font-normal text-base text-grey-7 dark:text-mauve-2',
};
